/**
 * Hook to get effective UID for data fetches.
 * When impersonating: returns impersonated user's ID.
 * Otherwise: returns current user's ID.
 * Use this when fetching "current user" data so impersonation works correctly.
 */
import { useAuth } from '../contexts/AuthContext';
import { useImpersonation } from '../contexts/ImpersonationContext';

export function useEffectiveUid() {
  const { currentUser } = useAuth();
  const { effectiveUserId } = useImpersonation();
  return effectiveUserId ?? currentUser?.uid ?? null;
}
